import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import SEO from '../../components/base/SEO';

export default function ServicesPage() {
  const { t } = useTranslation(['services', 'common']);

  const services = [
    {
      id: 1,
      title: t('services:service1.title'),
      subtitle: t('services:service1.subtitle'),
      description: t('services:service1.description'),
      features: [
        t('services:service1.feature1'),
        t('services:service1.feature2'),
        t('services:service1.feature3'),
        t('services:service1.feature4'),
        t('services:service1.feature5'),
      ],
      image: 'https://public.readdy.ai/ai/img_res/f7a37abca7009ade7aceb201322ef676.jpg',
      color: 'from-[#8B9D83] to-[#7A8C72]',
    },
    {
      id: 2,
      title: t('services:service2.title'),
      subtitle: t('services:service2.subtitle'),
      description: t('services:service2.description'),
      features: [
        t('services:service2.feature1'),
        t('services:service2.feature2'),
        t('services:service2.feature3'),
        t('services:service2.feature4'),
        t('services:service2.feature5'),
      ],
      image: 'https://readdy.ai/api/search-image?query=Scientific%20cellular%20rejuvenation%20concept%20with%20fresh%20organic%20vegetables%20fruits%20and%20supplements%20arranged%20elegantly%20on%20clean%20white%20marble%20surface%2C%20microscopic%20cell%20imagery%20overlay%2C%20modern%20biohacking%20aesthetic%2C%20sage%20green%20and%20gold%20accents%2C%20high-end%20wellness%20photography%2C%20minimalist%20composition%2C%20natural%20lighting%2C%20quiet%20luxury%20style%2C%20anti-aging%20health%20concept%20with%20scientific%20precision&width=800&height=900&seq=fmd-protocol-service&orientation=portrait',
      color: 'from-[#A8B89D] to-[#8B9D83]',
    },
    {
      id: 3,
      title: t('services:service3.title'),
      subtitle: t('services:service3.subtitle'),
      description: t('services:service3.description'),
      features: [
        t('services:service3.feature1'),
        t('services:service3.feature2'),
        t('services:service3.feature3'),
        t('services:service3.feature4'),
        t('services:service3.feature5'),
      ],
      image: 'https://readdy.ai/api/search-image?query=Happy%20healthy%20child%20eating%20colorful%20nutritious%20meal%20at%20beautiful%20modern%20dining%20table%2C%20fresh%20organic%20vegetables%20and%20fruits%20arranged%20artfully%2C%20warm%20natural%20lighting%2C%20clean%20minimalist%20kitchen%20interior%20with%20sage%20green%20accents%2C%20professional%20lifestyle%20photography%2C%20quiet%20luxury%20aesthetic%2C%20family%20wellness%20concept%2C%20joyful%20atmosphere%2C%20high-end%20health-conscious%20home%20environment&width=800&height=900&seq=child-nutrition-service&orientation=portrait',
      color: 'from-[#B8D4A8] to-[#A8B89D]',
    },
    {
      id: 4,
      title: t('services:service4.title'),
      subtitle: t('services:service4.subtitle'),
      description: t('services:service4.description'),
      features: [
        t('services:service4.feature1'),
        t('services:service4.feature2'),
        t('services:service4.feature3'),
        t('services:service4.feature4'),
        t('services:service4.feature5'),
      ],
      image: 'https://readdy.ai/api/search-image?query=Small%20group%20of%20women%20in%20elegant%20wellness%20workshop%20setting%2C%20sitting%20together%20in%20circle%20with%20nutritionists%2C%20bright%20modern%20space%20with%20large%20windows%2C%20sage%20green%20and%20cream%20interior%20design%2C%20natural%20light%2C%20professional%20health%20coaching%20session%2C%20community%20support%20atmosphere%2C%20quiet%20luxury%20aesthetic%2C%20sophisticated%20group%20consultation%2C%20warm%20welcoming%20environment&width=800&height=900&seq=group-intensive-service&orientation=portrait',
      color: 'from-[#C8D4B8] to-[#B8D4A8]',
    },
  ];

  return (
    <div className="min-h-screen bg-[#FAF9F6]">
      <SEO
        title={t('services:seo.title')}
        description={t('services:seo.description')}
        keywords={t('services:seo.keywords')}
        ogImage="https://readdy.ai/api/search-image?query=Luxury%20wellness%20consultation%20room%20with%20two%20professional%20nutritionists%20working%20together%20with%20client%2C%20elegant%20minimalist%20interior%20design%2C%20sage%20green%20and%20cream%20color%20palette%2C%20natural%20light%20streaming%20through%20large%20windows%2C%20high-end%20medical%20spa%20atmosphere%2C%20professional%20healthcare%20photography%2C%20quiet%20luxury%20aesthetic%2C%20sophisticated%20consultation%20setting%20with%20modern%20technology%20and%20natural%20elements&width=800&height=900&seq=vip-tandem-service&orientation=portrait"
      />
      <Navigation />

      {/* Hero Section */}
      <section className="relative pt-20 sm:pt-32 pb-10 sm:pb-20 px-5 sm:px-8 bg-white">
        <div className="max-w-6xl mx-auto text-center">
          <h1 className="text-2xl sm:text-4xl md:text-6xl font-light text-[#4A5D44] mb-4 sm:mb-6 leading-tight" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            {t('services:hero.title')}
          </h1>
          <div className="w-16 sm:w-24 h-px bg-[#8B9D83] mx-auto mb-4 sm:mb-8"></div>
          <p className="text-sm sm:text-lg font-light text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {t('services:hero.description')}
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-8 sm:py-20 px-5 sm:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid sm:grid-cols-2 gap-6 sm:gap-12">
            {services.map((service) => (
              <article
                key={service.id}
                className="group relative bg-white rounded-sm overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 hover:-translate-y-1 sm:hover:-translate-y-2 cursor-pointer"
              >
                <div className="relative h-48 sm:h-80 overflow-hidden">
                  <img
                    src={service.image}
                    alt={`${service.title} — ${service.subtitle}: ${service.description}`}
                    width="800"
                    height="900"
                    loading="lazy"
                    decoding="async"
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className={`absolute inset-0 bg-gradient-to-t ${service.color} opacity-20 group-hover:opacity-30 transition-opacity duration-500`}></div>
                </div>

                <div className="p-5 sm:p-10">
                  <div className="mb-3 sm:mb-6">
                    <h2 className="text-xl sm:text-3xl font-light text-[#4A5D44] mb-1 sm:mb-2" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                      {service.title}
                    </h2>
                    <p className="text-xs font-light text-[#8B9D83] tracking-widest uppercase">
                      {service.subtitle}
                    </p>
                  </div>

                  <p className="text-sm font-light text-gray-600 leading-relaxed mb-4 sm:mb-8">
                    {service.description}
                  </p>

                  <ul className="space-y-2 sm:space-y-3 mb-5 sm:mb-8">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start gap-2 sm:gap-3 text-xs sm:text-sm font-light text-gray-600">
                        <span className="text-[#8B9D83] mt-0.5 flex-shrink-0">
                          <i className="ri-checkbox-circle-fill text-base sm:text-lg" aria-hidden="true"></i>
                        </span>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>

                  <Link
                    to="/payment"
                    className="inline-block w-full text-center px-6 sm:px-8 py-3 sm:py-4 bg-[#8B9D83] text-white text-xs sm:text-sm font-light tracking-widest uppercase rounded-sm hover:bg-[#7A8C72] transition-all duration-300 whitespace-nowrap cursor-pointer"
                    aria-label={t('services:learnMoreAria', { service: service.title })}
                  >
                    {t('services:learnMore')}
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Bottom CTA Section */}
      <section className="py-12 sm:py-24 px-5 sm:px-8 bg-[#F5F7F3]">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-xl sm:text-3xl md:text-5xl font-light text-[#4A5D44] mb-4 sm:mb-6 leading-tight" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            {t('services:cta.title')}
          </h2>
          <p className="text-sm sm:text-lg font-light text-gray-600 mb-6 sm:mb-10 leading-relaxed">
            {t('services:cta.description')}
          </p>
          <Link
            to="/payment"
            className="inline-block px-7 sm:px-12 py-3 sm:py-4 bg-[#8B9D83] text-white text-xs sm:text-sm font-light tracking-widest uppercase rounded-sm hover:bg-[#7A8C72] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            aria-label={t('services:cta.buttonAria')}
          >
            {t('services:cta.button')}
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}